import { render, staticRenderFns } from "./locationSearch.vue?vue&type=template&id=20d95cb2"
import script from "./locationSearch.vue?vue&type=script&lang=js"
export * from "./locationSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports